module.exports = __webpack_public_path__ + "img/pic.f8894cb8.jpg";